import { render, staticRenderFns } from "./TaskListenerConfig.vue?vue&type=template&id=35603637&scoped=true"
import script from "./TaskListenerConfig.vue?vue&type=script&lang=js"
export * from "./TaskListenerConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskListenerConfig.vue?vue&type=style&index=0&id=35603637&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35603637",
  null
  
)

export default component.exports